module.exports = __webpack_public_path__ + "static/media/rss.fed05cbb.svg";